<div
  class="bg-foreground rounded-xl border border-divider p-4 h-full flex flex-col">
  <div class="flex items-center gap-2 mb-3">
    <div
      class="w-8 h-8 rounded-lg flex items-center justify-center"
      [class]="colorClass">
      <mat-icon
        [svgIcon]="icon"
        class="w-4 h-4"
        style="font-size: 18px"></mat-icon>
    </div>
    <span class="text-sm font-medium text-default flex-auto">{{ title }}</span>
    @if (count !== null) {
      <span class="text-xs font-semibold bg-base rounded-full px-2 py-0.5">{{
        count
      }}</span>
    }
  </div>

  @if (item) {
    @if (isLoading(item)) {
      <div class="flex flex-col gap-2 flex-auto">
        @for (i of [1, 2, 3]; track i) {
          <div class="h-10 bg-base rounded animate-pulse"></div>
        }
      </div>
    } @else if (isError(item)) {
      <app-widget-error
        appClickStopPropagation
        (retry)="retry.emit()"></app-widget-error>
    } @else {
      <div class="flex flex-col gap-1 flex-auto">
        <ng-content></ng-content>
      </div>

      @if (link) {
        <a
          [routerLink]="link"
          class="flex items-center gap-1 text-xs text-primary-600 mt-3 hover:underline">
          <span>View all</span>
          <mat-icon
            svgIcon="mat:chevron_right"
            class="w-3 h-3"
            style="font-size: 14px"></mat-icon>
        </a>
      }
    }
  }
</div>
